// import NProgress from 'nprogress';
// import 'nprogress/nprogress.css';
import { createRouter, createWebHistory } from 'vue-router';
import { useMenuStore } from '@/stores/menu';
import constantRoutes from './constantRoutes';

const routes: any = constantRoutes;
const router = createRouter({
  history: createWebHistory(),
  routes,
});

export { constantRoutes };

export const route404 = { path: '*', redirect: '/404', hidden: true };
const whiteList = ['/login', '/404', '/500', '/pass-reset', '/logic'];
router.beforeEach(async (to, from, next) => {
  if (whiteList.indexOf(to.path) > -1) {
    if (to.path === '/login' && localStorage.getItem('token')) {
      next('/');
      return;
    }
    // 常规未登录时返回登录页，咚咚回调时带参数code，因此拿fullPath匹配
    if (to.fullPath === '/logic' && !localStorage.getItem('token')) {
      next('/login');
      return;
    }
    next();
    return;
  }
  if (!localStorage.getItem('token')) {
    next('/login');
    return;
  }
  if (to.matched.length === 0) {
    next('/404');
    return;
  }
  if (!whiteList.includes(to.path) && localStorage.getItem('token')) {
    const menuStore = useMenuStore();
    await menuStore.setActivePath(to.path);
    //添加后跳转到应访问的地址
    next();
    return;
  }
});

export default router;
